/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OrderResponseDto = {
    /**
     * ID заказа
     */
    id: number;
    /**
     * ID двигателя
     */
    engineId: number;
    /**
     * Код заказа
     */
    orderCode: string;
    /**
     * Серийный номер двигателя
     */
    serialNumber: string;
    /**
     * Фамилия и Имя
     */
    ownerName: string;
    /**
     * Компания
     */
    company: string;
    /**
     * Дата создания
     */
    createdAt: string;
    /**
     * Дата обновления
     */
    updatedAt: string;
    /**
     * Тип работы
     */
    workType: OrderResponseDto.workType;
    /**
     * UUID отчета
     */
    reportFileUuids?: Array<string>;
    /**
     * Комментарий
     */
    comment?: string;
    /**
     * Статус заказа
     */
    status: OrderResponseDto.status;
};

export namespace OrderResponseDto {

    /**
     * Тип работы
     */
    export enum workType {
        MAINTENANCE = 'MAINTENANCE',
        REPAIR = 'REPAIR',
        INSPECTION = 'INSPECTION',
        UPGRADE = 'UPGRADE',
        REPLACEMENT = 'REPLACEMENT',
        CALIBRATION = 'CALIBRATION',
    }

    /**
     * Статус заказа
     */
    export enum status {
        NEW = 'NEW',
        IN_PROGRESS = 'IN_PROGRESS',
        COMPLETED = 'COMPLETED',
        CANCELLED = 'CANCELLED',
    }


}

